<template>
  <v-dialog
    :value="paramModalState"
    fullscreen
  >
    <v-card>
      <v-toolbar
        flat
        height="50"
        color="teal"
      >
        <v-toolbar-title class="subheading white--text">
          <span>Gib die gewünschten Filter an</span>
        </v-toolbar-title>

        <v-spacer />
        <v-btn
          icon
          dark
          @click="closeParamModal"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-layout
          justify-center
          row
        >
          <v-flex
            xs12
            md8
            lg6
          >
            <v-card flat>
              <v-card-text>
                <v-select
                  v-model="genere"
                  :items="searchBase.movieGenres"
                  item-text="option"
                  item-value="value"
                  :dense="true"
                  label="Genre"
                />

                <v-select
                  v-model="rate"
                  :items="searchBase.rate"
                  item-text="option"
                  item-value="value"
                  :dense="true"
                  label="Zuschauerbewertung"
                />

                <v-select
                  v-model="country"
                  :items="searchBase.country"
                  item-text="option"
                  item-value="value"
                  :dense="true"
                  label="Veröffentlichungsland"
                />

                <v-select
                  v-model="sort"
                  :items="searchBase.sort"
                  item-text="option"
                  item-value="value"
                  :dense="true"
                  label="Ergebnisse sortieren"
                />

                <v-text-field
                  v-model="yearFrom"
                  name="year-from"
                  label="Filmjahr ab"
                  type="number"
                />

                <v-text-field
                  v-model="yearTill"
                  name="year-till"
                  label="Filmjahr bis"
                  type="number"
                />

                <v-text-field
                  v-model="actor"
                  name="actor"
                  label="Name des Schauspielers"
                  type="text"
                />
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  flat
                  color="white"
                  @click="onClear"
                >
                  Alle Filter löschen
                </v-btn>

                <v-btn
                  flat
                  color="white"
                  @click="onSubmit"
                >
                  Finden
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>


<script>
import { searchBase } from '../config/config';

export default {

  data() {
    return {
      searchBase,
      genere: '',
      rate: '',
      country: '',
      sort: '',
      yearFrom: '',
      yearTill: '',
      actor: '',
    };
  },

  computed: {
    paramModalState() {
      return this.$store.getters.paramModal;
    },
  },
  methods: {

    closeParamModal() {
      this.$store.commit('closeParamModal');
    },

    onSubmit() {
      const customParams = {
        genere: this.genere,
        rate: this.rate,
        country: this.country,
        sort: this.sort,
        yearFrom: this.yearFrom,
        yearTill: this.yearTill,
        actor: this.actor,
      };

      this.$store.commit('closeParamModal');
      this.$store.commit('resetParamsResults');
      this.$router.push('/erweiterte-suche');
      this.$store.dispatch('getParamResults', { params: customParams });
    },
    onClear() {
      this.genere = '';
      this.rate = '';
      this.country = '';
      this.sort = '';
      this.yearFrom = '';
      this.yearTill = '';
      this.actor = '';
    },
  },
};
</script>
